export const routerConfigToRouteKey = <
  P extends Record<string, unknown> = Record<string, unknown>,
>(
  config: P
) =>
  Object.keys(config).reduce(
    (acc, routeKey) => ({ ...acc, [routeKey]: routeKey }),
    {} as Record<keyof P, string>
  );
